import type {
  Action,
  ResourceType,
  SagaCallbacks,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestFetchEntity = ({
  list,
  callbacks,
  requestKey,
  resourceType,
}): Action => ({
  type: actionTypes.REQUEST_FETCH_ENTITY,
  list,
  callbacks,
  requestKey,
  resourceType,
});

export const requestAddFolder = ({
  payload,
  callbacks,
}): Action => ({
  type: actionTypes.REQUEST_ADD_FOLDER,
  payload,
  callbacks,
});

export const requestUpdateFolder = ({
  id,
  payload,
  callbacks,
}): Action => ({
  type: actionTypes.REQUEST_UPDATE_FOLDER,
  id,
  payload,
  callbacks,
});

export const requestAddEntity = ({
  payload,
  resourceType,
  callbacks,
  list,
}: {
  payload: any
  resourceType: string
  list?: string
  callbacks?: any
}): Action => ({
  type: actionTypes.REQUEST_ADD_ENTITY,
  payload,
  callbacks,
  resourceType,
  list,
});

export const requestUpdateEntity = ({
  id,
  payload,
  endNotify,
  requestType,
  resourceType,
  callbacks,
}: {
  id: string | number,
  payload: any,
  endNotify?: boolean,
  requestType?: string,
  resourceType: string,
  callbacks?: any,
}): Action => ({
  type: actionTypes.REQUEST_UPDATE_ENTITY,
  id,
  payload,
  endNotify,
  requestType,
  resourceType,
  callbacks,
});

export const requestDeleteEntity = ({
  id,
  qs,
  resourceType,
  callbacks,
}: {
  id: number,
  qs?: any,
  resourceType: string,
  callbacks?: any,
}): Action => ({
  type: actionTypes.REQUEST_DELETE_ENTITY,
  id,
  qs,
  resourceType,
  callbacks,
});

export const requestFullEntity = ({
  id,
  requestType,
  resourceType,
}: {
  id: number,
  requestType?: string,
  resourceType: string,
}): Action => ({
  type: actionTypes.REQUEST_FULL_ENTITY,
  id,
  requestType,
  resourceType,
});

export const requestUpdateItems = ({
  resources,
  resourceType,
  callbacks,
}: {
  resources: any,
  resourceType: string,
  callbacks?: any,
}): Action => ({
  type: actionTypes.REQUEST_UPDATE_ITEMS,
  resources,
  resourceType,
  callbacks,
});

export const requestDeleteItems = ({
  resources,
  resourceType,
  callbacks,
}: {
  resources: any,
  resourceType: string,
  callbacks?: any,
}): Action => ({
  type: actionTypes.REQUEST_DELETE_ITEMS,
  resources,
  resourceType,
  callbacks,
});

export const requestCopyItems = ({
  items,
  folderId,
  resourceType,
}): Action => ({
  type: actionTypes.REQUEST_COPY_ITEMS,
  items,
  folderId,
  resourceType,
});

export const requestDuplicateEntity = ({
  ids,
  folderIds,
  resourceType,
  callbacks,
}: {
  ids: number[];
  folderIds: number[];
  resourceType: ResourceType;
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_DUPLICATE_ENTITY,
  ids,
  folderIds,
  resourceType,
  callbacks,
});

export const requestMoveToFolder = ({
  items,
  targetId,
  resourceType,
  callbacks,
}): Action => ({
  type: actionTypes.REQUEST_MOVE_TO_FOLDER,
  items,
  targetId,
  resourceType,
  callbacks,
});

export const requestSaveAsTemplate = ({
  id,
  payload,
  resourceType,
  callbacks,
}: {
  id: number,
  resourceType: string,
  payload: any,
  callbacks?: any,
}): Action => ({
  type: actionTypes.REQUEST_SAVE_AS_TEMPLATE,
  id,
  payload,
  resourceType,
  callbacks,
});

export const requestFetchResources = ({
  requestKey,
  callbacks,
}): Action => ({
  type: actionTypes.REQUEST_FETCH_RESOURCES,
  requestKey,
  callbacks,
});
